import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { inr } from "@/lib/format";
import { Section } from "./kit";

export default function BeatOutstanding({ reloadKey, compact = false }) {
  const { data } = useFetch("/customer-receivables/by-beat", null, reloadKey);
  const [open, setOpen] = useState(null);
  const rows = data || [];
  return (
    <Section title="Outstanding — Beat-wise" testid="beat-outstanding">
      {rows.length === 0 && <p className="text-sm text-slate-500">No outstanding.</p>}
      <div className="divide-y divide-slate-100">
        {rows.map((b) => (
          <div key={b.beat_id}>
            <button className="flex w-full items-center justify-between py-2.5 text-left" onClick={() => setOpen(open === b.beat_id ? null : b.beat_id)} data-testid={`beat-out-${b.beat_name}`}>
              <span className="flex items-center gap-2 font-semibold">{open === b.beat_id ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}{b.beat_name}<span className="text-xs font-normal text-slate-500">{b.customer_count} customers</span></span>
              <span className="text-right font-mono text-sm">{!compact && <span className="mr-4 text-xs text-slate-500">WS {inr(b.wholesale)} · FMCG {inr(b.fmcg)}</span>}<b>{inr(b.total)}</b></span>
            </button>
            {open === b.beat_id && <div className="mb-2 rounded bg-slate-50 px-3 py-1">
              {b.customers.map((c) => <div key={c.id} className="flex justify-between py-1 text-sm"><span>{c.name} <span className="text-xs text-slate-500">{c.mobile}</span></span><span className="font-mono">{inr(c.total)}</span></div>)}
            </div>}
          </div>
        ))}
      </div>
      {rows.length > 0 && <div className="mt-2 flex justify-between border-t pt-2 font-bold"><span>Total</span><span className="font-mono">{inr(rows.reduce((s, r) => s + r.total, 0))}</span></div>}
    </Section>
  );
}
